import React from "react";
import { SvgIcon } from "@mui/material";

const CustomerIcon = ({ fill }) => {
  return (
    <>
      <SvgIcon>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C9.79 2 8 3.79 8 6C8 8.21 9.79 10 12 10C14.21 10 16 8.21 16 6C16 3.79 14.21 2 12 2ZM12 8C10.9 8 10 7.1 10 6C10 4.9 10.9 4 12 4C13.1 4 14 4.9 14 6C14 7.1 13.1 8 12 8Z"
            fill={fill}
          />
          <path
            d="M12 12C7.58 12 4 13.79 4 16V18C4 18.55 4.45 19 5 19H19C19.55 19 20 18.55 20 18V16C20 13.79 16.42 12 12 12ZM18 17H6V16C6 14.9 8.69 14 12 14C15.31 14 18 14.9 18 16V17Z"
            fill={fill}
          />
        </svg>
      </SvgIcon>
    </>
  );
};

export default CustomerIcon;
